// extracted by mini-css-extract-plugin
export default {"biobar-optional-links":"styles_biobar-optional-links__J3-wl"};